export default {"src":"/_next/static/media/Raraity_Primary_Icon_Chartreuse.2e9c99e2.svg","height":1728,"width":1439,"blurWidth":0,"blurHeight":0};